import axios from "axios";
import request from "../../request";
import { generateGuestToken } from "../../utils/Publicpage";

const campaignCache = {}; // Simple in-memory cache

// Function to get the current timestamp
const getCurrentTimestamp = () => new Date().getTime();

export const CAMPAIGNPRODUCTS = (dispatch, TOKEN, COMPANYID, STOREID, USERID, Id, storeid, categoryId, type_id, currentpage) => {
  async function fetchCampaignProducts() {
    const cacheKey = `${Id}-${STOREID}-${categoryId}-${type_id}`;

    // Check if data for this page is already cached
    // Check if data for this page is already cached
    const isCached = campaignCache[cacheKey] &&
      campaignCache[cacheKey].data &&
      campaignCache[cacheKey].data[currentpage] &&
      (getCurrentTimestamp() - campaignCache[cacheKey].timestamp < 6 * 60 * 60 * 1000);

    if (isCached) {
      // Combine all pages that have been cached under this key
      const cachedPages = Object.values(campaignCache[cacheKey].data);
      const mergedProducts = cachedPages.flatMap(p => p.products);
      const totalCount = cachedPages[0]?.count || 0;

      dispatch({
        type: "CAMPAIGN_PRODUCTS_SUCCESS",
        payload: {
          count: totalCount,
          products: mergedProducts
        }
      });
      return;

    }

    const url = `${request.CAMPAIGNPRODUCTS}/`;
    dispatch({ type: 'CAMPAIGN_PRODUCTS_LOADING' });

    const body = {
      customer_id: USERID ? USERID.toString() : "0",
      storeId: STOREID.toString(),
      sliderid: Id.toString(),
      search: "",
      current_page: currentpage.toString(),
      brand_type: "",
      currentpage: currentpage,
      type_id: type_id.toString(),
      categoryId: categoryId ? categoryId.toString() : ""
    };

    const guestToken = generateGuestToken();

    try {
      const response = await axios({
        method: "post",
        url: url,
        data: body,
        headers: {
          "Authorization": `Bearer ${guestToken}`,
        }
      });

      if (response.data) {
        const responseData = response.data[0].data;
        const { products, count } = responseData;

        const payload = {
          count,
          products
        };

        // Initialize cache structure if not exists
        if (!campaignCache[cacheKey]) {
          campaignCache[cacheKey] = {
            data: {},
            timestamp: getCurrentTimestamp()
          };
        }
        // Store the current page's products
        campaignCache[cacheKey].data[currentpage] = {
          count,
          products
        };

        dispatch({
          type: "CAMPAIGN_PRODUCTS_SUCCESS",
          payload
        });
      } else {
        dispatch({
          type: 'CAMPAIGN_PRODUCTS_FAILURE',
          payload: 'No products data found'
        });
      }
    } catch (error) {
      dispatch({
        type: 'CAMPAIGN_PRODUCTS_FAILURE',
        payload: error.message
      });
    }
  }

  fetchCampaignProducts();
}

export const CAMPAIGNPRODUCTSFilterproduct = (dispatch, TOKEN, Id, STOREID, categoryId) => {
  async function fetchCampaignProductsFilter() {
    const url = `${request.CAMPAIGNPRODUCTSFilter}/`;

    dispatch({ type: 'CAMPAIGN_PRODUCTS_FILTER_LOADING' });

    const body = {
      storeId: STOREID.toString(),
      sliderid: Id.toString(),
    };

    const guestToken = generateGuestToken();

    try {
      const response = await axios.post(url, body, {
        headers: {
          "Authorization": `Bearer ${guestToken}`,
        }
      });

      if (response.data && Array.isArray(response.data)) {
        const responseData = response.data[0];
        const sliderdata = responseData.sliderdata;

        dispatch({
          type: "CAMPAIGN_PRODUCTS_FILTER_SUCCESS",
          payload: {
            responseData: responseData.data, // category + subcategories
            bannerImage: sliderdata.banner_image,
            responsiveImage: sliderdata.banner_image_mobile,
            filtertitle: sliderdata.title,
            filterdetails: sliderdata.description,
            thaititle: sliderdata.titlethai,
            filterdetailsthai: sliderdata.descriptionthai
          }
        });

      } else {
        dispatch({
          type: 'CAMPAIGN_PRODUCTS_FILTER_FAILURE',
          payload: 'No filter data found'
        });
      }
    } catch (error) {
      dispatch({
        type: 'CAMPAIGN_PRODUCTS_FILTER_FAILURE',
        payload: error.message
      });
    }
  }

  fetchCampaignProductsFilter();
};

